import { createFileRoute } from "@tanstack/react-router";
import { ChatPages } from "./-components/chats.page";
import { chatRouteSearchSchema } from "./-components/chat-route-search";

export const Route = createFileRoute("/_dashboard/$datasetSlug/(chats)/chats/$conversationId")({
  component: RouteComponent,
  validateSearch: chatRouteSearchSchema,
});

function RouteComponent() {
  return <ChatPages />;
}
